<template>
  <section>
    <div class="content_bg">
      <div class="blue_bg"></div>
      <img class="welcome_bg" height="38.31" src="@/assets/images/welcome_bg.png" />
      <div class="content">
        <div>
          <p class="welcome_text1">
            <span style="color: #215fe6">먼데이리스</span>는
            <br />
            <span style="color: #f75757">모바일 앱</span> 전문 
            <br/>
            개발사입니다.
          </p>
          <p class="welcome_text2">
            하이브리드보다 쉬운
            <span style="color: #a91eff">네이티브</span> 
            <br />개발, 배포, 운영으로 견적가를
            <br />낮추고 퀄리티를 올립니다
          </p>
        </div>
        <img width="300" src="@/assets/images/welcomebox_mobile.png" />
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "../components/Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 840px;
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
}
.blue_bg {
  position:absolute;
  width: 100vw;
  height: 160px; 
  bottom: 0;
  background-color: #215fe6;
}

.welcome_bg {
  position:absolute;
  width: 100vw;
  max-width: 100vw;
  bottom: 0;
  margin-bottom: 150px;
}

.content {
  position:absolute;
  text-align: center;
  width: 100wh;
  max-width: 100vw;
  padding-top: 70px;
}

.welcome_text1 {
  font-weight: 700;
  font-size: 40px;
  color: #000000;
  letter-spacing: -1px;
  margin-bottom: 0.5em;
}

.welcome_text2 {
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 20px;
  color: #495057;
  letter-spacing: 0;
  line-height: 28px;
}
</style>
  